import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { CategoryService } from '@services/category.service';
import { OpenstreetmapService } from '@services/openstreetmap.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import { MapsAPILoader } from "@agm/core";
import { google } from "google-maps";
import * as _ from 'lodash';
declare var google: google;
import * as $ from "jquery";
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-cbusiness',
  templateUrl: './cbusiness.component.html',
  styleUrls: ['./cbusiness.component.sass']
})
export class CbusinessComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  appCreateForm: FormGroup;
  params: any = [];
  response: any = [];
  country_code = "";
  error: any = { 'name': '', 'email': '', city: '', state: '', zip: '', address: '', country: '', 'streetAddress': '', isClosed: '', isClaimed: '', phone: '', fax: '' };
  btn_process = false;
  status_list: any = [];
  user_refresh: any = [];
  country_list: any = [];
  pathToMedia: any = {};
  image_paths: any = [];
  country = "";
  status_txt = '';
  final_hour: any = [];
  application = "";
  component = "";
  selected_category = "";
  weekday: any = [];
  hours_start: any = [];
  hours_end: any = [];
  day: any = [];
  hour_start: '';
  hour_end = '';
  start = '';
  end = '';
  sconfig: any = {};
  constructor(private _os: OpenstreetmapService,private MapsAPILoader: MapsAPILoader, private ngZone: NgZone, private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {

    if (!this._global.isAuthenticated()) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/create/business' } });
    } else {

      this.sconfig = {
        displayKey: "label",
        displayValue: "value",
        search: false,
        clearOnSelection: true
      }

      this.component = this._global.COMPONENTS_SB;
      this.application = "business";
      this.weekday = this._global.BUSINESS_WEEKDAY;
      this.hours_start = this._global.BUSINESS_HOURS_START;
      this.hours_end = this._global.BUSINESS_HOURS_END;
      this.appCreateForm = this.fb.group({
        status: [],
        latitude: [],
        longitude: [],
        name: [],
        isClaimed: ['true'],
        fax_dialCode: [],
        mobileUrl:[],
        fax_no: [],
        phone_dialCode: [],
        day: [],
        start: [],
        end: [],
        phone_no: [],
        isClosed: ['true'],
        email: [],
        streetAddress: [],
        address: [],
        countryCode: [],
        description: [],
        city: [],
        state: [],
        zip: [],
        hours: new FormArray([]),
        url: []
      });
      this.appCreateForm.get('day').setValue(0);
      this.start = '0000';
      this.appCreateForm.get('start').setValue('0000');
      this.end = '0000';
      this.appCreateForm.get('end').setValue('0000');

      let f = {
        'component': this.component,
        'application': this.application
      };
      this._formdataService.countries(f).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.country_list = this._global.getVal(data, 'response', '');
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });

      let THIS = this;
      let p = {
        'component': this.component,
        'application': 'category',
        'categoryType': this.application
      };
      this._categoryService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            let result = this._global.getVal(data, 'response', '');
            CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", '', this.application, true);
            $("div#" + this.application + "_category").click(function (e) {
              var $target = $(e.target);
              if ($target.attr("id") === "categoryCheck") {
                let result = Helper.getCategoryChecboxValues("categoryCheck", '');
                THIS.selected_category = Helper.categoryJsonText("categoryCheck");
              }
            });
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }

  }
  @ViewChild('streetAddress') public addressElement: ElementRef;
  ngOnInit() {
  }

  removeHour(index) {
    (this.appCreateForm.get('hours') as FormArray).removeAt(Number(index));
  }
  addHours() {
    const day = this.weekday.find(x => x.value == this.appCreateForm.value['day']);
    const start = this.hours_start.find(x => x.value == this.start);
    const end = this.hours_end.find(x => x.value == this.end);
    const hour = this.fb.group({
      day: [this.appCreateForm.value['day']],
      start: [this.start],
      end: [this.end],
      day_txt: [day['label']],
      start_txt: [start['label']],
      end_txt: [end['label']]
    });
    (this.appCreateForm.get('hours') as FormArray).push(hour);
    let d = this.appCreateForm.value['day'];
    if (d == 6) {
      d = 0;
    } else {
      d = parseInt(d) + 1;
    }
    this.appCreateForm.get('day').setValue(d);
  }


  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
    this.image_paths = [];
    this.image_paths.push(this.pathToMedia);
  }
  save() {
    this.error = { 'name': '', 'email': '', city: '', state: '', zip: '', address: '', country: '', 'streetAddress': '', isClosed: '', isClaimed: '', phone: '', fax: '' };
    let res = this.country_list.find(x => x.value == this.country_code);
    this.country = "";
    if (res) {
      this.country = res["label"];
    }
    this.btn_process = true;
    let r = this.appCreateForm.value;
    r.component = this.component;
    r.application = this.application;
    let p = this._global.generateParams(r, ['hours','customProperties']);
    p = this._global.paramsRemoveNull(p);
    p['categoryJson'] = Helper.getCategoryChecboxValues("categoryCheck", '');
    this.final_hour=[];
    let hour = {};
    let open = [];
    let result = [];
    Object.entries(this.appCreateForm.value['hours']).forEach(([key, value]) => {
      let hours = {};
      hours["is_overnight"] = "false";
      hours["day"] = value['day'];
      hours["start"] = value['start'];
      hours["end"] = value['end'];
      result.push(open.push(hours));
    });
    hour["open"] = open;
    this.final_hour.push(hour);
    p['hours'] = JSON.stringify(this.final_hour);
    let addressJson = {};
    addressJson["streetAddress"] = p['streetAddress'];
    addressJson["address"] = p['address'];
    addressJson["city"] = p['city'];
    addressJson["state"] = p['state'];
    addressJson["country"] = this.country;
    addressJson["zip"] = p['zip'];
    addressJson["latitude"] = p['latitude'];
    addressJson["longitude"] = p['longitude'];
    p['addressJson'] = JSON.stringify(addressJson);
    let phone = { "phone": {} };
    phone["phone"]["area"] = p['phone_dialCode'];
    phone["phone"]["number"] = p['phone_no']
    var fax = { "fax": {} };
    fax["fax"]["area"] = p['fax_dialCode'];
    fax["fax"]["number"] = p['fax_no'];
    p['phone'] = JSON.stringify(phone);
    p['fax'] = JSON.stringify(fax);
    p['country'] = this.country;

    if (!_.isEmpty(p['latitude']) && !_.isEmpty(p['longitude'])) {
      let latlongs = {};
      latlongs["lat"] = p['latitude'];
      latlongs["lon"] = p['longitude'];
      p['latlong'] = JSON.stringify(latlongs);
    }
    let delparm = ['day', 'start', 'end', 'phone_dialCode', 'fax_dialCode', 'fax_no', 'latitude', 'longitude', 'phone_no'];
    for (let key in delparm) {
      delete (p[delparm[key]]);
    }
    p['pathToMedia'] = JSON.stringify(this.pathToMedia);
    this._saveService.app(p).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          this.router.navigate(['/search/' + this.component + '/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  getAddress() {
    let THIS = this;
    this.MapsAPILoader.load().then(
      () => {
        console.log(google,google.maps.places);
     
          let automcomplete = new google.maps.places.Autocomplete(this.addressElement.nativeElement, { types: ["address"], componentRestrictions: { country: THIS.country_code } });
          automcomplete.addListener("place_changed", () => {

            let p = this.ngZone.run(() => {
              let place: google.maps.places.PlaceResult = automcomplete.getPlace();
                let address = place.address_components;
                let geometry = place.geometry;
                let THIS = this;
                THIS.appCreateForm.get('streetAddress').setValue(place["formatted_address"]);

                address.forEach(function (value) {
                  if (value["types"][0] == 'country') {
                    //  THIS.country_code= value["short_name"];
                    // THIS.appCreateForm.get('country').setValue( THIS.country_code);

                  } else if (value["types"][0] == 'locality') {
                    THIS.appCreateForm.get('city').setValue(value["long_name"]);
                  } else if (value["types"][0] == 'administrative_area_level_1') {
                    THIS.appCreateForm.get('state').setValue(value["long_name"]);
                  } else if (value["types"][0] == 'postal_code') {
                    THIS.appCreateForm.get('zip').setValue(value["long_name"]);
                  }
                });
                if (geometry) {
                  var lat = geometry.location.lat();
                  var lng = geometry.location.lng();
                  THIS.appCreateForm.get('latitude').setValue(lat);
                  THIS.appCreateForm.get('longitude').setValue(lng);

                }

            })
          })
        
      }
    )
  }
  returnZero() {
    return 0
  }
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  getDialCode(event) {
    console.log("dial event", event)
    let res = this.country_list.find(x => x.value == event);
    this.country = res["label"];
    this.country_code = this.appCreateForm.value["countryCode"];
    let p = {
      'component': this.component,
      'application': this.application,
      'countryCode': this.country_code
    };
    this._formdataService.dialCode(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.appCreateForm.get('phone_dialCode').setValue(this._global.getVal(data, 'response.dialCode', ''));
          this.appCreateForm.get('fax_dialCode').setValue(this._global.getVal(data, 'response.dialCode', ''));
          // this.response["dialCode"]=this._global.getVal(data, 'response.dialCode', '');
          //   this.response["countryCode"]=this._global.getVal(data, 'response.countryCode', '');
          console.log("this.response", this.response);
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', '');
  }



}